import { handleRteOverlayClick } from './handleRteOverlayClick'

type RteEditorWithFullscreen = {
  editorRef?: { current?: HTMLElement | null }
  requestProps?: { isPlugin?: boolean }
  isEntryInModal?: boolean
}

/**
 * Exits RTE fullscreen before actions that open entry-in-modal UI (e.g. “Open in overlay”).
 * Prefers clicking `.scrte-fullscreen-row-button` (same as the row toggle in the Editor).
 */
export const exitRteFullScreenIfActive = (editor?: RteEditorWithFullscreen | null): void => {
  const editorRef = editor?.editorRef
  const root = editorRef?.current
  if (!root?.classList?.contains('fullscreen')) {
    return
  }

  const fullscreenRowButton = root.querySelector<HTMLElement>('a.scrte-fullscreen-row-button')
  if (fullscreenRowButton) {
    fullscreenRowButton.click()
    return
  }

  handleRteOverlayClick(
    editorRef,
    Boolean(editor?.requestProps?.isPlugin),
    Boolean(editor?.isEntryInModal)
  )
}
